import { Link as LinkBase } from "@mindlercare/ui-web";
import { ComponentProps } from "react";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";

type BaseLinkProps = ComponentProps<typeof LinkBase>;

export type LinkProps = Omit<BaseLinkProps, "href"> &
  Pick<RouterLinkProps, "to" | "state">;

export const Link = (props: LinkProps) => {
  // styled-components `as` prop not reflected in TS overloads for intrinsic elements
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <LinkBase as={RouterLink as any} {...(props as any)} />;
};
